import { render, staticRenderFns } from "./FormProductSalePrice.vue?vue&type=template&id=4d3b7fe0&scoped=true&"
import script from "./FormProductSalePrice.vue?vue&type=script&lang=js&"
export * from "./FormProductSalePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b7fe0",
  null
  
)

export default component.exports